import React, { Component } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Button, Heading, IconCollection, Map } from '../../components';

import css from './ListingPage.module.css';
import { normalizeDeliveryOptions } from '../../util/data';


class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
    this.openDirections = this.openDirections.bind(this);
  }

  openDirections(lat, lng) {
    if (typeof window === "undefined") {
      console.warn("Window is not defined. Cannot open maps.");
      return;
    }
  
    if (!lat || !lng) {
      console.warn("Invalid coordinates");
      return;
    }
  
    const destination = `${lat},${lng}`;
    const userAgent = navigator.userAgent || "";
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isAndroid = /android/i.test(userAgent);
  
    let mapURL;
  
    if (isIOS) {
      // Apple Maps for iOS
      mapURL = `http://maps.apple.com/?daddr=${destination}`;
    } else {
      // Google Maps for Android and desktop
      mapURL = `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
    }
  
    window.open(mapURL, "_blank", "noopener,noreferrer");
  };
  

  render() {
    const { className, rootClassName, geolocation, publicData, listingId, mapsConfig, locationText, title } = this.props;

    const normalisedAccessibilityOptions = normalizeDeliveryOptions(publicData?.access_to_rentals || []).join(', ');
    const mainHeading = !!normalisedAccessibilityOptions
      ? <>{title} is available for {normalisedAccessibilityOptions}<span className={css.locationText}>{locationText}</span></>
      : <>{title} is available for rental <span className={css.locationText}>{locationText}</span></>;

    if (!geolocation) {
      return null;
    }

    const address = publicData && publicData.location ? publicData.location.address : '';
    const classes = classNames(rootClassName || css.panel, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey) }
      : { address, center: geolocation };
    const map = <Map {...mapProps} useStaticMap={false} />;

    return (
      <div className={classes}>
        <h4 className={css.headingMap}>Item Location</h4>
        <Heading as="h3" rootClassName={css.textMap}>
          {/* <FormattedMessage id="ListingPage.locationTitle" /> */}
          {mainHeading}
        </Heading>
        {this.state.isStatic ? (
          <button
            className={css.mapBox}
            onClick={() => {
              this.setState({ isStatic: false });
            }}
          >
            {map}
          </button>
        ) : (
          <div className={css.mapBox}>{map}</div>
        )}
        <Button type="button" onClick={() => this.openDirections(geolocation.lat, geolocation.lng)} className={css.directionBtn} variant='danger' arrow="right" icon={<IconCollection name="map_pin" />}>
          Get Direction
        </Button>
      </div>
    );
  }
}

SectionMapMaybe.defaultProps = {
  rootClassName: null,
  className: null,
  geolocation: null,
  listingId: null,
};

SectionMapMaybe.propTypes = {
  rootClassName: string,
  className: string,
  geolocation: propTypes.latlng,
  listingId: propTypes.uuid,
};

export default SectionMapMaybe;